import React from "react";
import { Descriptions,Typography } from "antd";
import { ellipseText } from "../../common/Common";
import { CommonCard } from "./formHelper";
import { checkIncomingDataType, fmpSmpColumns } from "./helper";

const { Text, Paragraph } = Typography;

const pick = (oldValue, newValue, mode) => {
  if(mode){
    return mode === "previous" ? oldValue : newValue;
  }else{
    return newValue
  }
};


export const adjEntryWithCard = (changes, _, type, mode, category) => {
  if (!changes?.length) return null;
 const oldConfig = changes[0]?.old_value ?? changes[0]?.new_value;
 const newConfig = changes[0]?.new_value ?? changes[0]?.old_value;

  return (
    <CommonCard minHeight={"120px"} maxHeight={"170px"} >
      {renderBaseRateDetails(oldConfig, newConfig, type, mode, category)}
    </CommonCard>
  );
};


export const adjEntryWithoutCard = (changes, _, type, mode) => {
  if(!changes?.length) return null;
  const oldConfig = changes[0]?.old_value ?? changes[0]?.new_value;
 const newConfig = changes[0]?.new_value ?? changes[0]?.old_value;

  return (
    <>
      {renderAccAdjustmentDetails(oldConfig, newConfig, type, mode)}
    </>
  );
}
 

const renderAccAdjustmentDetails = (oldConfig, newConfig, type = null, mode="") => {
  if (!oldConfig || !newConfig) return null;
  const {
    code: old_code,
    name: old_name,
    category: old_category,
  } = oldConfig || {};

  const {
    code: new_code,
    name: new_name,
    category: new_category,
  } = newConfig || {};

  const getStyle = (oldValue, newValue) => {
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  };

  const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(
      value
    )
      ? value
      : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{ellipseText(String(displayValue).replace(/_/g, " "), 10, true)}</Paragraph>;
    }
    return (
      <Text>{ellipseText(displayValue.replace(/_/g, " "), 10, true)}</Text>
    );
  };

  return (
    <Descriptions
      size="small"
      column={{ xl: 3, lg: 3, md: 3, sm: 2, xs: 2 }}
      style={{ textAlign: "left" }}
    >
      <Descriptions.Item label="Adj Code">
        {mode === "previous" ? (
          renderText(old_code)
        ) : (
          <span style={getStyle(old_code, new_code)}>
            {renderText(new_code)}
          </span>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Adj Name">
        {mode === "previous" ? (
          renderText(old_name)
        ) : (
          <span style={getStyle(old_name, new_name)}>
            {renderText(new_name)}
          </span>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Adj Category">
        {mode === "previous" ? (
          renderText(old_category)
        ) : (
          <span style={getStyle(old_category, new_category)}>
            {renderText(new_category)}
          </span>
        )}
      </Descriptions.Item>
    </Descriptions>
  );
};

const renderBaseRateDetails = (oldConfig, newConfig, type = null, mode="", category) => {
  if (!oldConfig || !newConfig) return null;
  const {
    apply_cwt: old_apply_cwt,
    charge_type: old_charge_type,
    require_smp:old_require_smp,
    weight_units: old_weight_units,
  } = oldConfig || {};

  const {
    apply_cwt: new_apply_cwt,
    charge_type: new_charge_type,
    require_smp: new_require_smp,
    weight_units: new_weight_units,
  } = newConfig || {};

  const getStyle = (oldValue, newValue, mode) => {
      if (mode === "previous") return {};  
    if (oldValue !== newValue) {
      return { backgroundColor: "yellow" };
    }
    return {};
  };

  const renderText = (value) => {
    const displayValue = !["N/A", "n/a", undefined, null, NaN, ""].includes(
      value
    )
      ? value
      : "N/A";

    if (type === "REMOVED") {
      return <Paragraph delete>{ellipseText(String(displayValue).replace(/_/g, " "), 10, true)}</Paragraph>;
    }
    return (
      <Text>{ellipseText(displayValue.replace(/_/g, " "), 10, true)}</Text>
    );
  };

  const currentScreen = window.location.pathname
  const renderColSpan = currentScreen.includes("accounts") ? 4 : 3;

  return (
    <Descriptions
      size="small"
      column={{ xl: renderColSpan, lg: renderColSpan, md: 12, sm: 24, xs: 24 }}
      style={{ textAlign: "left" }}
    >
      <Descriptions.Item label="Apply cwt">
        <span style={getStyle(old_apply_cwt, new_apply_cwt, mode)}>
          {renderText(pick(old_apply_cwt, new_apply_cwt, mode) === "true" ? "Yes" : "No")}
        </span>
      </Descriptions.Item>

       <Descriptions.Item label="Charge type">
        <span style={getStyle(old_charge_type, new_charge_type, mode)}>
          {renderText(pick(old_charge_type, new_charge_type, mode))}
        </span>
      </Descriptions.Item>

        <Descriptions.Item label="require SMP">
        <span style={getStyle(old_require_smp, new_require_smp, mode)}>
          {renderText(pick(old_require_smp, new_require_smp, mode) === "true" ? "Yes" : "No")}
        </span>
      </Descriptions.Item>
     

      <Descriptions.Item label="Weight Units">
        <span style={getStyle(old_weight_units, new_weight_units, mode)}>
          {renderText(pick(old_weight_units, new_weight_units, mode))}
        </span>
      </Descriptions.Item>
    </Descriptions>
  );
};

export const columnsExtracter = (data=[]) => {
  if(!data.length) return [];
  const staticKeys = new Set(["zone_name", "min_charge"]);
  const dynamicKeys = Object.keys(data[0]).filter((key) => !staticKeys.has(key));

  return dynamicKeys.map((key) => ({
    title: key,
    dataIndex: key,
    key,
     width: 120,
    align: "center",
    render: (value) => checkIncomingDataType(value) ?? "N/A",
  }))
};

export const buildColumns = (data) => {
    const dynamicCols = columnsExtracter(data) || [];
  return [...fmpSmpColumns, ...dynamicCols]
}